import React from 'react';
import { RISK_SEVERITY } from '@silverfort-nodelibs/common/utils/insight';
import { Icons, SEVERITIES_COLORS, SEVERITY } from '@silverfort/sf-components';

type SeverityInfo = {
    color: string;
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
    label: string;
    value: number;
};

export const SEVERITIES_INFO: Record<number, SeverityInfo> = {
    [RISK_SEVERITY.CRITICAL]: {
        color: SEVERITIES_COLORS[SEVERITY.CRITICAL].tailwind,
        icon: Icons.SeverityHigh,
        label: 'Critical',
        value: SEVERITY.CRITICAL
    },
    [RISK_SEVERITY.HIGH]: {
        color: SEVERITIES_COLORS[SEVERITY.HIGH].tailwind,
        icon: Icons.SeverityHigh,
        label: 'High',
        value: SEVERITY.HIGH
    },
    [RISK_SEVERITY.MEDIUM]: {
        color: SEVERITIES_COLORS[SEVERITY.MEDIUM].tailwind,
        icon: Icons.SeverityMid,
        label: 'Medium',
        value: SEVERITY.MEDIUM
    },
    [RISK_SEVERITY.LOW]: {
        color: SEVERITIES_COLORS[SEVERITY.LOW].tailwind,
        icon: Icons.SeverityLow,
        label: 'Low',
        value: SEVERITY.LOW
    },
    [RISK_SEVERITY.SECURE]: {
        color: SEVERITIES_COLORS[SEVERITY.NONE].tailwind,
        icon: Icons.ShieldSecurity,
        label: 'None',
        value: SEVERITY.NONE
    }
};
